import React, { useState } from 'react';
import Header from "../../../../src/components/Header/Header";
import { DataGridPro } from "@mui/x-data-grid-pro";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import Controls from '../../Loyalty/dealerManagement/Controls';
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';
import moment from 'moment'
import { onExportExcel } from '../../../_helpers/exportExcel';

const INITIAL_FILTER_STATE = {
    "userId": "",
    "fromDate": null,
    "toDate": null
}

function onYearFarword(fromDate) {
    const addOneYear = moment(fromDate).add(1, 'years').format('DD MMM YYYY')
    const minusOneDay = moment(addOneYear).subtract(1, 'days').format('DD MMM YYYY')
    return minusOneDay;
}

function onYearBack(fromDate) {

    let minusOneYear = moment(fromDate).subtract(1, 'years').format('DD MMM YYYY')
    let addOneDay = moment(minusOneYear).add(1, 'days').format('DD MMM YYYY')
    let tdate = moment(moment(fromDate).format('DD MMM YYYY'));
    let minDate = moment(moment("2021-01-01").format('DD MMM YYYY'))
    const dif = tdate.diff(minDate, 'days');
    const l = moment(fromDate).subtract(dif, 'days').format('DD MMM YYYY');
    return dif > 365 ? addOneDay : l;
}

const MINIMUM_DATE = new Date("2021-01-01");

const UserRoleChange = () => {
    const [filterState, setFilterState] = useState(INITIAL_FILTER_STATE);
    const [dateError, setDateError] = useState("");
    const [showLoading, setShowLoading] = useState(false)
    const [userRows, setUserRows] = useState([])

    function handleFilterChange(e) {
        setDateError("")
        setFilterState({ ...filterState, [e.target.name]: e.target.value });
    }

    const onFilterSearch = () => {
        setUserRows([])
        if (filterState.userId === "") {
            setDateError("userId")
            return 0;
        }

        let fDate = filterState.fromDate ? moment(filterState.fromDate).format("DD-MM-YYYY") : ""
        let tDate = filterState.toDate ? moment(filterState.toDate).format("DD-MM-YYYY") : ""
        let queryString = `userId=${filterState.userId}&fromDate=${fDate}&toDate=${tDate}`;

        setShowLoading(true)
        const requestOptions = {
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
            },
        };
        Axios.get(`${API_URL_UMS}audit/userRoleAuditReport?${queryString}`,
            requestOptions
        )
            .then((response) => {
                setUserRows(response.data)
                setShowLoading(false)
            })
            .catch((error) => { });
    }

    const columns = [
        {
            field: "userEmailId",
            headerName: "User Email Id",
            headerAlign: "center",
            align: 'center',
            width: 200,
            sortable: true
        },
        {
            field: "userName",
            headerName: "User Name",
            headerAlign: "center",
            align: 'center',
            width: 200
        },

        {
            field: "currentRole",
            headerName: "Old Role",
            headerAlign: "center",
            align: 'center',
            width: 180,
            sortable: true
        },
        {
            field: "newRole",
            headerName: "New Role",
            headerAlign: "center",
            align: 'center',
            width: 180,
            sortable: true
        },
        {
            field: "createdBy",
            headerName: "Assigned By",
            headerAlign: "center",
            align: 'center',
            width: 120,
            sortable: true
        },
        {
            field: "createdDateMilliSec",
            headerName: "Assigned At",
            headerAlign: "center",
            align: 'center',
            width: 200,
            sortable: true,
            renderCell: ({ row }) => {
                return <div>{moment(row.createdDateMilliSec).format("DD-MM-YYYY HH:mm")}</div>;
            },
        }
    ];

    var fdate = moment(onYearFarword(filterState.fromDate));
    var now = moment();

    function modifyColumns(columns) {
        return columns.map((item) => {
            return ({
                label: item.headerName,
                value: item.field,
                ...item
            })
        })
    }

    function modifyRows(rowdata) {
        const data = rowdata.map((item) => {
            return ({
                ...item,
                createdDateMilliSec:moment(item.createdDateMilliSec).format("DD-MM-YYYY HH:mm")
            })
        })
        return data
    }

    return (
        <div className="content-wrapper">
            <Header title="User Role Audit Report" />
            <div className="row ipad_css ">
                <div className="mainScroll">
                    <div className="col-12 mt-2">
                        <div className="pCalFormControll">
                            <Grid container>
                                <Grid item md={3} xs={12}>
                                    <Controls.Input
                                        name="userId"
                                        label="Username"
                                        onChange={handleFilterChange}
                                        size="small"
                                        {...(dateError === "userId" && { error: "Required" })}
                                    />
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <Controls.DatePicker
                                        name="fromDate"
                                        label="From Date"
                                        onChange={handleFilterChange}
                                        value={filterState.fromDate}
                                        maxDate={
                                            typeof filterState.toDate === "object" && filterState.toDate != null && filterState.toDate != "Invalid Date"
                                                ? filterState.toDate
                                                : new Date()
                                        }
                                        minDate={
                                            typeof filterState.toDate === "object" && filterState.toDate != null && filterState.toDate != "Invalid Date"
                                                ? onYearBack(filterState.toDate)
                                                : MINIMUM_DATE
                                        }
                                    />
                                </Grid>

                                <Grid item md={3} xs={12}>
                                    <Controls.DatePicker
                                        name="toDate"
                                        label="To Date"
                                        onChange={handleFilterChange}
                                        value={filterState.toDate}
                                        minDate={
                                            typeof filterState.fromDate === "object" && filterState.fromDate != null && filterState.fromDate != "Invalid Date"
                                                ? filterState.fromDate
                                                : MINIMUM_DATE
                                        }
                                        maxDate={
                                            fdate >= now ||
                                                onYearFarword(filterState.fromDate) === "Invalid date"
                                                ? new Date()
                                                : onYearFarword(filterState.fromDate)
                                        }
                                    />
                                </Grid>
                                <Grid item md xs display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        className="btncolor"
                                        size="small"
                                        sx={{ m: 1 }}
                                        onClick={onFilterSearch}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        className="outlineButton"
                                        size="small"
                                        sx={{ m: 1 }}
                                        onClick={() => onExportExcel(modifyColumns(columns), modifyRows(userRows), "User_Role_Report", "User_Role_Report")}
                                    >
                                        Download
                                    </Button>
                                </Grid>

                            </Grid>
                        </div>
                        <div className="DataGridContainer">
                            <DataGridPro
                                style={{ fontSize: "14px" }}
                                rows={userRows}
                                columns={columns}
                                localeText={{
                                    noRowsLabel: "No Data",
                                }}
                                disableColumnMenu={true}
                                disableColumnReorder={true}
                                disableColumnSelector={true}
                                disableColumnResize={true}
                                loading={showLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserRoleChange